module.exports = __webpack_public_path__ + "static/img/sync-skills2.ea2b5eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/sync-skills2.jpg
// module id = e9iV
// module chunks = 1